import { useDayPicker } from 'react-day-picker'

import styles from '../DatePicker.module.scss'

import ArrowIcon from '../../assets/arrow.svg'

export const PreviousMonthButton = () => {
    const { goToMonth, previousMonth } = useDayPicker()

    const handleClick = () => previousMonth && goToMonth(previousMonth)

    return (
        <button className={styles.previousMothButton} onClick={handleClick}>
            <ArrowIcon />
        </button>
    )
}
